/** @type {import('tailwindcss').Config} */
const { heroui } = require("@heroui/react");

module.exports = {
  mode: 'jit',
  content: [
    './src/pages/**/*.{js,ts,jsx,tsx}',
    './src/components/**/*.{js,ts,jsx,tsx}',
    './src/hooks/**/*.{js,ts,jsx,tsx}',
    './src/features/**/*.{js,ts,jsx,tsx}',
    './src/app/**/*.{js,ts,jsx,tsx}',
    "./node_modules/@heroui/theme/dist/**/*.{js,ts,jsx,tsx}",
  ],
  theme: {
    extend: {
      dropShadow: {
        'merge-pdf': '-8px -8px 0px #f8fafc',
      },
      animation: {
        slideInRight: 'slideInRight 0.5s ease-out',
        slideInLeft: 'slideInLeft 0.5s ease-out',
        returnSlideInRight: 'returnSlideInRight 0.3s ease-out forwards',
        returnSlideInLeft: 'returnSlideInLeft 0.3s ease-out forwards',
        progressFill: 'progressFill 4.5s cubic-bezier(0.33, 1, 0.68, 1) forwards',
        progressFillFast:
          'progressFill 1.5s cubic-bezier(0.33, 1, 0.68, 1) forwards',
        unlockProgressFill: 'progressFill 30s linear forwards',
      },
      keyframes: {
        slideInRight: {
          '0%': { transform: 'translateX(100%)' },
          '100%': { transform: 'translateX(0)' },
        },
        returnSlideInRight: {
          '0%': { transform: 'translateX(0)' },
          '100%': { transform: 'translateX(120%)' },
        },
        slideInLeft: {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(0)' },
        },
        returnSlideInLeft: {
          '0%': { transform: 'translateX(0)' },
          '100%': { transform: 'translateX(-120%)' },
        },
        progressFill: {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(0)' },
        },
      },
      colors: {
        'primary-blue': '#4b7eff',
        'primary-dark-blue': '#3c65cc',
        'primary-light-blue': '#6fa9ff',
        'primary-extra-light-blue': '#dbe7ff',
        'primary-extra-light-blue2': '#F2F8FD',
        dark: '#292a33',
        'gray-dark': '#454655',
        'gray-medium': '#787887',
        'gray-light': '#a9aabc',
        'gray-lighter': '#cbccd7',
        'gray-light2': '#cecfd4',
        'gray-light3': '#ecefd4',
        'gray-medium2': '#e5e6eb',
        'gray-lightest': '#eeeef2',
        'gray-very-light': '#f6f7f8',
        'blue-light': '#ecf5ff',
        white: '#ffffff',
        'red-dark': '#b50031',
        'red-light': '#f43f5e',
        green: '#1bcf63',
        yellow: '#f4ac3f',
      },
      backgroundImage: {
        'progres-lineer': 'linear-gradient(90deg, #A9AABC, #6FA9FF)',
      },
      boxShadow: {
        'preview-paging': '0px 2px 8px 0px #0000001F',
        dropdown: '0px 2px 8px 0px #0000001F',
      },
      margin: {
        section: '6.25rem',
      },
      padding: {
        section: '6.25rem',
      },
      fontFamily: {
        barlow: ['Barlow'],
      },
      borderRadius: {
        extra: '0.3125rem',
        'extra-lg': '0.625rem',
      },
      screens: {
        xs: '540px',
        xxs: '375px',
      },
    },
  },
  plugins: [
    heroui({
      layout: {
        radius: {
          small: '5px', // rounded-small
          medium: '10px', // rounded-medium
          large: '15px', // rounded-large
        },
      },
    }),
  ],
};
